import React, { useContext } from 'react';
import SimpleCheckbox from './SimpleCheckbox';
import AppContext from './AppContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './components/Accordion';

function PokedexFiltersVariants() {
  const {
    baseSpeciesAllowed,
    setBaseSpeciesAllowed,
    gmaxAllowed,
    setGmaxAllowed,
    megasAllowed,
    setMegasAllowed,
    regionalsAllowed,
    setRegionalsAllowed,
    baseFormesAllowed,
    setBaseFormesAllowed,
  } = useContext(AppContext);

  return (
    <Accordion type="single" collapsible defaultValue="basic-filter">
      <AccordionItem value="basic-filter">
        <AccordionTrigger>Basic Filter</AccordionTrigger>
        <AccordionContent>
          <SimpleCheckbox
            labelText="Base Species"
            checked={baseSpeciesAllowed}
            disabled={false}
            onChange={() => setBaseSpeciesAllowed(!baseSpeciesAllowed)}
          />
          <SimpleCheckbox
            labelText="Base Formes"
            checked={baseFormesAllowed}
            disabled={false}
            onChange={() => setBaseFormesAllowed(!baseFormesAllowed)}
          />
          <SimpleCheckbox
            labelText="Mega Evolution"
            checked={megasAllowed}
            onChange={() => setMegasAllowed(!megasAllowed)}
            disabled={false}
          />
          <SimpleCheckbox
            labelText="Gigantamax"
            checked={gmaxAllowed}
            onChange={() => setGmaxAllowed(!gmaxAllowed)}
            disabled={false}
          />
          <SimpleCheckbox
            labelText="Regional Variants"
            checked={regionalsAllowed}
            onChange={() => setRegionalsAllowed(!regionalsAllowed)}
            disabled={false}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default PokedexFiltersVariants;
